import { render, staticRenderFns } from "./PagamentoDetalheAprovacaoJustificada.vue?vue&type=template&id=bc04ceba"
import script from "./PagamentoDetalheAprovacaoJustificada.vue?vue&type=script&lang=js"
export * from "./PagamentoDetalheAprovacaoJustificada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports